/* eslint-disable no-nested-ternary,no-restricted-globals */
import { connect } from 'react-redux';

import { Component } from 'react';
import { actions } from 'forms/rrf';
import classnames from 'classnames';

class Spinner extends Component {
  handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
    }
  };

  constructor(props) {
    super(props);

    this.state = {
      value: this.getValue(),
    };
  }

  getValue() {
    const { value, min, max } = this.props;
    let val = 0;

    if (value) {
      if (typeof value === 'string' || value instanceof String) {
        val = parseInt(value) || '';
      }
      if (Number.isInteger(value)) {
        val = value;
      }
    }

    val = val > max ? max : val;
    val = val < min ? min : val;

    return val;
  }

  UNSAFE_componentWillMount() {
    const { model, dispatch, value } = this.props;

    if (model) {
      dispatch(actions.change(model, value));
    }

    this.setState({value});
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.state.value !== nextProps.value) {
      if (this.props.model) {
        this.props.dispatch(actions.change(this.props.model, nextProps.value));
      }
      this.setState({value: nextProps.value});
    }
  }

  increment(e) {
    const {max, step} = this.props;
    let val = parseInt(this.state.value);

    val = max !== undefined ? val >= max ? max : val + step : val + step;

    this.handleChange(e, val);
  }

  decrease(e) {
    const {min, step} = this.props;
    let val = parseInt(this.state.value);

    val = min !== undefined ? val - 1 < min ? min : val - step : val - step;

    this.handleChange(e, val);
  }

  handleChange(event, value) {
    const {
      model, dispatch, min, max, disabled
    } = this.props;

    if (disabled) return;

    let val = parseInt(value || event.target.value);

    if (!isNaN(val)) {
      val = val > max ? max : val;
      val = val < min ? min : val;
    } else {
      val = 0;
    }

    if (val !== this.state.value) {
      this.setState({value: val}, () => {
        if (model) {
          dispatch(actions.change(model, val));
          dispatch(actions.resetValidity(model));
        }
        if (this.props.onChange) {
          this.props.onChange({target: {value: val}});
        }
      });
    }
  }

  render() {
    return (
      <div className={`Spinner ${this.props.className}`}>
        <input
          className="Spinner-input"
          disabled={this.props.disabled}
          onChange={event => this.handleChange(event)}
          onKeyPress={this.handleKeyPress}
          pattern="\d*"
          type="text"
          value={this.state.value}
        />
        <div
          className={`Spinner-button-up ${classnames({disabled: this.props.disabled})}`}
          onClick={event => this.increment(event)}
        >
          <i className="glyphicon glyphicon-chevron-up"/>
        </div>
        <div
          className={`Spinner-button-down ${classnames({disabled: this.props.disabled})}`}
          onClick={event => this.decrease(event)}
        >
          <i className="glyphicon glyphicon-chevron-down"/>
        </div>
      </div>
    );
  }
}

Spinner.defaultProps = {
  step: 1,
  min: 1,
  max: 100,
  disabled: false,
  required: false,
  className: ''
};

export default connect()(Spinner);
